import React from "react";
import Amplify from "aws-amplify";
import params from "../Params";
import {withAuthenticator} from "aws-amplify-react";
import {NavBarWithAuth} from "../NavBar";
import withSimGps from "../SimGps/SimGps";

Amplify.configure({
    Auth: {
        // Amazon Cognito Region
        region: params.COGNITO_REGION,
        // Amazon Cognito User Pool ID
        userPoolId: params.COGNITO_POOL_ID,
        // Amazon Cognito Web Client ID
        userPoolWebClientId: params.COGNITO_CLIENT_ID,
    }
});


function withNavBar(WrappedComponent) {

    return class extends React.Component {

        render() {
            return  <div> <NavBarWithAuth/> <WrappedComponent {...this.props}/> </div> ;
        }
    }
}


function withUserData(WrappedComponent) {

    return class extends React.Component {
        constructor(props){
            super(props);

            // Don't wrap to HOC in render() method !
            this.authenticatedComp = withAuthenticator(withNavBar(withSimGps(WrappedComponent)), {
                // Render a sign out button once logged in
                includeGreetings: true,
            });

        }

        render() {
            return  React.createElement(this.authenticatedComp, this.props);
        }
    }
}

export default withUserData;
